import React, { useCallback, useContext, useEffect } from 'react';
import InfoTile from './InfoTile';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsStatsAction } from '../../../../../store/actions/dashboard/transactionsStats';
import styled from 'styled-components';
import socketContext from '../../../../../context/SocketContext';

const ContentHeader = styled.div``;

const Content = styled.div`
  padding-top: 10px;
  text-align: right;

  h3 {
    padding: 10px 0px;
    margin: 0px;
    font-size: 1.5em;
  }
`;

const InfoRow = () => {
  const dispatch = useDispatch();
  const transactionsStats = useSelector((state) => state?.dashboard?.transactionsStats);

  useEffect(() => {
    dispatch(getTransactionsStatsAction());
  }, [dispatch]);

  const refreshTransactionStats = useCallback(() => {
    dispatch(getTransactionsStatsAction());
  }, [dispatch]);

  const socket = useContext(socketContext);

  useEffect(() => {
    socket.on('TRANSACTION_CREATED', refreshTransactionStats);
    socket.on('TRANSACTION_POSTED', refreshTransactionStats);
    socket.on('TRANSACTION_CANCELLED', refreshTransactionStats);

    return () => {
      socket.off('TRANSACTION_CREATED', refreshTransactionStats);
      socket.off('TRANSACTION_POSTED', refreshTransactionStats);
      socket.off('TRANSACTION_CANCELLED', refreshTransactionStats);
    };
  });

  const currencyProps = { minimumFractionDigits: 2, currency: 'CZK', style: 'currency' };

  return (
    <>
      <InfoTile icon={<AccountBalanceWalletOutlinedIcon style={{ fontSize: '5em' }} />} color={'#e53935'}
                lastUpdate={transactionsStats?.data?.lastUpdate}>
        <Content>
          <ContentHeader>
            <FormattedMessage id={'stats.receipt.count'} />
          </ContentHeader>
          {transactionsStats?.state === 'SUCCESS' && (
            <h3>
              <FormattedNumber value={transactionsStats?.data?.closed_transaction_count || 0}
                               minimumFractionDigits={0} />/
              <FormattedNumber value={transactionsStats?.data?.transaction_count || 0} minimumFractionDigits={0} />
            </h3>
          )}
        </Content>
      </InfoTile>
      <InfoTile icon={<LocalAtmOutlinedIcon style={{ fontSize: '5em' }} />} color={'#00acc1'}
                lastUpdate={transactionsStats?.data?.lastUpdate}>
        <Content>
          <ContentHeader>
            <FormattedMessage id={'payment.cash'} />
          </ContentHeader>
          <h3>
            {transactionsStats?.state === 'SUCCESS' && (
              <FormattedNumber value={transactionsStats?.data?.total_cash || 0} {...currencyProps} />
            )}
          </h3>
        </Content>
      </InfoTile>
      <InfoTile icon={<PaymentOutlinedIcon style={{ fontSize: '5em' }} />} color={'#43a047'}
                lastUpdate={transactionsStats?.data?.lastUpdate}>
        <Content>
          <ContentHeader>
            <FormattedMessage id={'payment.card'} />
          </ContentHeader>
          <h3>
            {transactionsStats?.state === 'SUCCESS' && (
              <FormattedNumber value={transactionsStats?.data?.total_card || 0} {...currencyProps} />
            )}
          </h3>
        </Content>
      </InfoTile>
    </>
  );
};

export default InfoRow;
